import { useParams } from "next/navigation";
import { TransactionCreateAble } from "../Transactions/TransactionModal/TransactionModal";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Portfolio/PortfolioStats/Empty";
const I18n = I18nUtil.createScoped(Translations);
export const Empty = () => {
  const { portfolioId: id } = useParams<{ portfolioId: string }>();

  const onClick = async () => {
    await TransactionCreateAble({
      mode: "add",
      initialData: {
        accountId: id,
      },
    });
  };

  return (
    <div className="flex justify-center gap-1 py-2 bg-background_white_overlay5 rounded-b-xl">
      <button
        aria-label="Empty"
        data-openreplay-label={`Empty Button | ${I18n.t("Add Transaction")}`}
        id="btn-empty"
        className="underline body_medium_s text-content_brand_primary"
        onClick={onClick}
      >
        {I18n.t("Add Transaction")}
      </button>
      <div className="body_s text-content_tertiary">
        {I18n.t("for more insights.")}
      </div>
    </div>
  );
};
